import { render, staticRenderFns } from "./Genders.vue?vue&type=template&id=e239ba8a&"
import script from "./Genders.vue?vue&type=script&lang=js&"
export * from "./Genders.vue?vue&type=script&lang=js&"
import style0 from "./Genders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports